import { v4 as uuidv4 } from 'uuid';
import { PluginProvider } from '../../../system/providers/plugin';
import i18n from '../../../i18n';
import { CreateVariant } from '../../MasterTabsProvider';
import { typeReport } from '../DashboardBusinessControls/interfaces';
import AnalysisSalesLotPluginView from './AnalysisSalesLotPluginView';
import AnalysisSalesLotGridPluginSettings from './AnalysisSalesLotGridPluginSettings';

export const AnalysisSalesLotTab = (variant?: CreateVariant, idGlobal?: string, tabId?: string, contractorName?: string, reportType?: keyof typeof typeReport): ITab => {

    const t = (value: string) => i18n.t("sidePanel." + value);

    const getTabTitle = () => {
        function truncateString(str: string, maxLength: number): string {
            if (!str) return '';
            return str.length > maxLength
                ? `${str.substring(0, maxLength)}...`
                : str;
        }

        if (!reportType) return t("accounting.submenu.analysisSalesLot");

        switch (reportType) {
            case 'SalesReport':
                return `Продажи - ${truncateString(contractorName as string, 25)}`;
            default:
                return t("accounting.submenu.analysisSalesLot");
        }
    };

    return {
        id: uuidv4(),        
        title: getTabTitle(),
        view: {
            content:    
            AnalysisSalesLotGridPluginSettings
                        ?   <PluginProvider plugin={AnalysisSalesLotGridPluginSettings()}>
                                <AnalysisSalesLotPluginView gridId={uuidv4()} plugin={AnalysisSalesLotGridPluginSettings()} tabId={tabId}/>
                            </PluginProvider>
                        : 
                        <p> Справочник не настроен </p>
        }
    }
}

export default AnalysisSalesLotTab
